import { IConsultantMast } from "../../models/ConsultantMast";

export const EmptySubmission: IConsultantMast = {
    identityType: "Email ID",
    consultant_ID: undefined,

    consultant_Name: '',
    consultant_Email_ID: '',
    consultant_Home_No: undefined,
    consultant_Job_Title: '',
    visa_Status: undefined,
    consultant_State: undefined,
    consultant_City: undefined,
    total_Experience: undefined,
    availability: undefined,
    faceToFaceInterview: "No",
    hourly_Rate: undefined,
    concent: undefined,
    mathingProfilePer: undefined,
    tax_Term: "C2C All Inclusive",
    dobdd: '',
    dobmm: '',
    dobyyyy: '',
    dob: '',
    degree: undefined,
    contact_Person_EmailID: '',
    ssn: '',
    consultant_Country: undefined,
    vendor_Company_ID: undefined,
    submissionType: undefined,
    university_Name: '',
    contact_Person_Name: '',
    annual_Salary: undefined,
    passoutYear: undefined,
    phone_No: undefined,

    university: {
        university_ID: 0,
        university_Name: ''
    },
    city: {
        city_ID: 0,
        city_Name: ''
    },
    state: {
        state_ID: 0,
        state_Name: ''
    },
    country: {
        country_ID: 0,
        country_Name: ''
    },
    company: {
        vendor_Company_ID: 0,
        vendor_Company_Name: ''
    },

    r1_Company_Name: "",
    r1_POC_Name: "",
    r1_Phone: undefined,
    r1_Email: "",
    r2_Company_Name: "",
    r2_POC_Name: "",
    r2_Phone: undefined,
    r2_Email: "",
    r3_Company_Name: "",
    r3_POC_Name: "",
    r3_Phone: undefined,
    r3_Email: ""
}